import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { InvestableAssetsForm } from "./InvestableAssetsForm";
import { useNavigate } from "react-router-dom";

/**
 * Investable Assets page - Mobile implementation
 * Full-screen wrapper with swipe navigation (< 768px)
 * Delegates form rendering to the shared InvestableAssetsForm component.
 */
function InvestableAssetsMobile() {
  const navigate = useNavigate();

  return (
    <SettingsPageLayout
      title="Investable Assets"
      category="investableAssets"
      loading={false}
      onBack={() => navigate("/settings")}
    >
      <InvestableAssetsForm />
    </SettingsPageLayout>
  );
}

export default InvestableAssetsMobile;
